import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const SkeletonContainer = styled(Box)`
  ${({ theme }) => css`
    width: 330px;
    height: 152px;
    padding: 16px;
    border-radius: 10px;
    border: 1px solid ${theme.colors.border.light};
    background: ${theme.colors.lightest};
    box-shadow: 4px 4px 8px 0 ${theme.colors.background.hover};
    display: flex;
    justify-content: space-between;
    border-top: 12px solid ${theme.colors.border.light};
  `}
`

export const SkeletonLeftBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  gap: 8px;
`

export const SkeletonIconBox = styled(Box)`
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 8px;
`

export const SkeletonLine = styled.div<{ width?: string; height?: string }>`
  ${({ theme, width = '100%', height = '16px' }) => css`
    width: ${width};
    height: ${height};
    background: linear-gradient(
      90deg,
      ${theme.colors.border.light} 25%,
      #f0f0f0 50%,
      ${theme.colors.border.light} 75%
    );
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 4px;

    @keyframes skeleton-loading {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
  `}
`
